// React 项目的入口文件

// 导入必要的依赖
import React from 'react';              // 导入 React 核心库
import ReactDOM from 'react-dom/client'; // 导入 ReactDOM，用于将 React 组件渲染到页面
import './index.css';                   // 导入全局样式文件
import App from './App';                // 导入主应用组件

// 创建应用的根节点
// ReactDOM.createRoot 是 React 18 的新特性，用于启用并发模式
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement  // 获取 public/index.html 中的 root 元素
);

// 渲染应用
root.render(
  // StrictMode 是一个用于突出显示应用程序中潜在问题的工具
  <React.StrictMode>
    <App />  {/* 渲染 App 组件 */}
  </React.StrictMode>
);
